<template>
  <div class="container">
    <iframe
      src="/1/#/4"
      scrolling="no"
      border="0"
      frameborder="no"
      framespacing="0"
      allowfullscreen="true"
    >
    </iframe>
  </div>
</template>

<script>
export default {
  name: '',
  components: {},
  props: [],
  data() {
    return {}
  },
  watch: {},
  computed: {},
  created() {},
  mounted() {},
  methods: {},
}
</script>

<style lang="scss" scoped>
.container {
  width: 100%;
  height: 100vh;
  iframe {
    width: 100%;
    height: 100%;
  }
}
</style>